import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';

class CoachingProgramme extends VenueRegistrationFormModal {
	constructor() {
		super({
			modalSelector: '#js-program-landing-form-modal',
			triggerSelectors: ['.js-program-landing-add-coaching', '.js-program-landing-edit-coaching'],
			stepsEndpointAttr: 'coaching-steps-endpoint',
			submitEndpointAttr: 'coaching-submit-endpoint',
			logPrefix: 'CoachingProgramme'
		});
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: this.totalSteps,
			formType: FormTypes.StepForm,
			hasSeparator: true,
			isBackButtonEnabled: true,
			radioAnswerField: 'id',
			isRenderDependentQuestion: true,
			conditionalStepsVisiblity: true,
			exitButtonLabel: 'Save and Exit',
			exitButtonClasses: 'lta-form-generator__form-exit-button--underlined',
			nextStepButtonLabel: 'Save and continue',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue'
			}
		};
	}
}

VenueRegistrationFormModal.boot(CoachingProgramme);

export default CoachingProgramme;
